// extracted by mini-css-extract-plugin
export var addDetails = "_1-l";
export var addEditButton = "_1-b";
export var addressFields = "_1-2";
export var animationContainer = "_1-0";
export var closeButton = "_1-p";
export var customerDetails = "_1-x";
export var customerInformationWrapper = "_1-6";
export var dropdowns = "_1-4";
export var error = "_1-k";
export var fields = "_1-n";
export var flex = "_1-m";
export var grow = "_1-3";
export var icon = "_1-d";
export var imageButton = "_1-q";
export var imagesWrapper = "_1-s";
export var itemDetails = "_1-i";
export var itemSelectionHeader = "_1-9";
export var label = "_1-w";
export var lineItemImage = "_1-j";
export var lineItemReturnedWrapper = "_1-h";
export var lineItemWrapper = "_1-g";
export var modalContent = "_1-f";
export var modalFooter = "_1-1";
export var multipleChoiceAnswer = "_1-u";
export var multipleChoiceAnswersWrapper = "_1-t";
export var orderButton = "_1-z";
export var orderLabel = "_1-10";
export var orderSelection = "_1-y";
export var question = "_1-v";
export var search = "_1-e";
export var selectCheckbox = "_1-a";
export var selectionWrapper = "_1-8";
export var spinner = "_1-c";
export var subheader = "_1-5";
export var title = "_1-7";
export var uploadedImage = "_1-o";
export var uploadedImageWrapper = "_1-r";